<template>
  <svg class="connection-line-svg" ref="lineSvg"></svg>
</template>

<script>
export default {
  name: 'ConnectionLines',
  props: {
    // 左侧数据列表
    leftDataList: {
      type: Array,
      required: true
    },
    // 右侧数据列表
    rightDataList: {
      type: Array,
      required: true
    },
    // 右侧数据中表示关联左侧索引的字段名
    relationField: {
      type: String,
      default: 'detailIndex'
    }
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.onResize);
    this.$nextTick(() => {
      setTimeout(() => {
        this.drawConnectionLines();
      }, 300);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    // 绘制梯形连接线
    drawTrapezoid(leftTop, leftBottom, rightTop, rightBottom, color = '#f56c6c', type) {
      const svg = this.$refs.lineSvg;
      const typeList = [
        { code: '0', color: '#e5eeff' }, // 与明细背景色一致
        { code: '1', color: '#fff3e8' }, // 与明细背景色一致
        { code: '2', color: '#fce5e5' }, // 与明细背景色一致
        { code: '3', color: '#e1f3d8' }, // 与明细背景色一致
        { code: '4', color: '#f0f9eb' }  // 与明细背景色一致
      ];
      const colorItem = typeList.find((item) => item.code === type);
      const selectedColor = colorItem ? colorItem.color : '#0256FF';

      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      const d = `
        M ${leftTop.x},${leftTop.y}
        L ${rightTop.x},${rightTop.y}
        L ${rightBottom.x},${rightBottom.y}
        L ${leftBottom.x},${leftBottom.y}
        Z
      `;
      path.setAttribute('d', d);
      path.setAttribute('fill', selectedColor);
      path.setAttribute('fill-opacity', '0.6'); // 增加不透明度
      path.setAttribute('stroke', selectedColor);
      path.setAttribute('stroke-width', '1.5'); // 增加边框宽度
      svg.appendChild(path);
    },

    // 绘制连接线
    drawConnectionLines() {
      console.log('ConnectionLines.drawConnectionLines 被调用');
      console.log('左侧数据:', this.leftDataList);
      console.log('右侧数据:', this.rightDataList);
      // 清空之前的SVG内容
      const svg = this.$refs.lineSvg;
      if (!svg) {
        console.error('SVG引用不存在');
        return;
      }
      svg.innerHTML = '';

      // 动态设置SVG高度为右侧发票表格内容高度，确保最后一条发票能被覆盖
      const rightTable = document.querySelector('.invoice-table');
      const leftTable = document.querySelector('.detail-table');
      if (rightTable && svg) {
        // 使用两个表格的最大高度
        const maxHeight = Math.max(
          rightTable.scrollHeight || 0,
          leftTable ? leftTable.scrollHeight || 0 : 0
        );
        svg.style.height = maxHeight + 'px';
        console.log('设置SVG高度:', maxHeight + 'px');
      } else {
        console.error('找不到右侧表格或SVG元素');
        console.log('this.$el:', this.$el);
        console.log('parentElement:', this.$el.parentElement);
      }

      // 获取SVG的位置信息
      const svgRect = svg.getBoundingClientRect();
      const svgWidth = svgRect.width;
      console.log('SVG宽度:', svgWidth);

      // 跟踪当前已绘制路径的最下方位置
      let currentBottomY = 0;

      // 为每种类型绘制连接色块
      ['0', '1', '2', '3', '4'].forEach((type) => {
        const leftRange = this.getTypeRange('before', type);
        const rightRange = this.getTypeRange('after', type);

        // 根据不同情况绘制连接色块
        if (leftRange && rightRange) {
          // 左右都有数据 - 绘制完整连接色块
          const leftTop = { x: 0, y: leftRange.top };
          const leftBottom = { x: 0, y: leftRange.bottom };
          const rightTop = { x: svgWidth, y: rightRange.top };
          const rightBottom = { x: svgWidth, y: rightRange.bottom };

          this.drawTrapezoid(leftTop, leftBottom, rightTop, rightBottom, '', type);

          // 更新当前最下方位置
          currentBottomY = Math.max(leftRange.bottom, rightRange.bottom);
        } else if (leftRange && !rightRange) {
          // 只有左边有数据 - 删除的数据
          // 右边的 top 和 bottom 使用当前最下方位置 + 20px
          const rightY = currentBottomY + 20;

          const leftTop = { x: 0, y: leftRange.top };
          const leftBottom = { x: 0, y: leftRange.bottom };
          const rightTop = { x: svgWidth, y: rightY };
          const rightBottom = { x: svgWidth, y: rightY }; // top 和 bottom 的 y 一致

          this.drawTrapezoid(leftTop, leftBottom, rightTop, rightBottom, '', type);

          // 更新当前最下方位置
          currentBottomY = Math.max(leftRange.bottom, rightY);
        } else if (!leftRange && rightRange) {
          // 只有右边有数据 - 新增的数据
          // 左边的 top 和 bottom 使用当前最下方位置 + 20px
          const leftY = currentBottomY;
          const leftTop = { x: 0, y: leftY };
          const leftBottom = { x: 0, y: leftY }; // top 和 bottom 的 y 一致
          const rightTop = { x: svgWidth, y: rightRange.top };
          const rightBottom = { x: svgWidth, y: rightRange.bottom };

          this.drawTrapezoid(leftTop, leftBottom, rightTop, rightBottom, '', type);

          // 更新当前最下方位置
          currentBottomY = Math.max(leftY, rightRange.bottom);
        }
      });
    },

    // 获取指定类型数据在表格中的范围（顶部和底部位置，排除间距对象）
    getTypeRange(tableType, type) {
      const dataList = tableType === 'before' ? this.leftDataList : this.rightDataList;
      console.log(`获取${tableType}表格中类型${type}的范围, 数据列表:`, dataList);

      // 找到该类型的所有非间距对象索引
      const typeIndexes = [];
      dataList.forEach((item, index) => {
        if (tableType === 'before') {
          // 对于明细表格，直接使用索引作为类型
          if (index === parseInt(type)) {
            typeIndexes.push(index);
            console.log(`找到左侧匹配: 索引=${index}`);
          }
        } else {
          // 对于发票表格，使用detailIndex作为类型
          console.log(
            `检查右侧项: index=${index}, detailIndex=${item[this.relationField]}, type=${type}`
          );
          if (item[this.relationField] === parseInt(type)) {
            typeIndexes.push(index);
            console.log(`找到右侧匹配: 索引=${index}, detailIndex=${item[this.relationField]}`);
          }
        }
      });

      // 如果没有实际数据，返回null
      if (typeIndexes.length === 0) {
        console.log(`类型${type}在${tableType}表格中没有匹配项`);
        return null;
      }

      console.log(`类型${type}在${tableType}表格中的索引:`, typeIndexes);
      // 使用实际数据的位置计算
      const result = this.calculateRangeFromIndexes(tableType, typeIndexes);
      console.log(`类型${type}在${tableType}表格中的范围:`, result);
      return result;
    },

    // 根据索引数组计算位置范围
    calculateRangeFromIndexes(tableType, indexes) {
      console.log(`计算${tableType}表格索引${indexes}的位置范围`);

      // 获取表格容器 - 修改查找方式
      let tableContainer;
      if (tableType === 'before') {
        // 左侧表格 - 明细表格
        tableContainer = document.querySelector('.detail-table');
      } else {
        // 右侧表格 - 发票表格
        tableContainer = document.querySelector('.invoice-table');
      }

      if (!tableContainer) {
        console.error(`找不到${tableType}表格容器`);
        return null;
      }

      console.log(`找到${tableType}表格容器:`, tableContainer);

      // 获取表格中的所有行
      const tableRows = tableContainer.querySelectorAll('.el-table__body tr');
      console.log(`${tableType}表格中的行数:`, tableRows.length);

      // 直接使用索引获取行
      const matchingRows = [];
      indexes.forEach((index) => {
        if (tableRows[index]) {
          matchingRows.push({ row: tableRows[index], index });
          console.log(`找到匹配行: 索引=${index}`);
        } else {
          console.log(`未找到索引为${index}的行`);
        }
      });

      if (matchingRows.length === 0) {
        console.error(`在${tableType}表格中没有找到匹配的行`);
        return null;
      }

      const firstRow = matchingRows[0].row;
      const lastRow = matchingRows[matchingRows.length - 1].row;

      // 获取单元格而不是行，以便更精确地对齐
      const firstCell = firstRow.querySelector('td');
      const lastCell = lastRow.querySelector('td');
      const firstCellRect = firstCell ? firstCell.getBoundingClientRect() : firstRow.getBoundingClientRect();
      const lastCellRect = lastCell ? lastCell.getBoundingClientRect() : lastRow.getBoundingClientRect();
      const svgRect = this.$refs.lineSvg.getBoundingClientRect();

      console.log(`${tableType}表格第一行位置:`, firstCellRect);
      console.log(`${tableType}表格最后一行位置:`, lastCellRect);
      console.log('SVG位置:', svgRect);

      // 修正最后一行bottom超出SVG范围的问题
      let bottom = lastCellRect.bottom - svgRect.top;
      // 获取SVG实际高度
      const svgHeight = this.$refs.lineSvg.offsetHeight;
      if (bottom > svgHeight) {
        bottom = svgHeight;
      }

      // 计算相对于SVG的位置，添加偏移量使连接线与单元格内容对齐
      const top = firstCellRect.top - svgRect.top + 5; // 添加5px的偏移量使连接线更好地对齐

      return { top, bottom };
    },

    // 窗口大小变化时重新绘制连接线
    onResize() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.drawConnectionLines();
        }, 100);
      });
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/styles/connection-lines.scss';

.connection-line-svg {
  width: 100%;
  height: calc(100% - 60px);
  margin-top: 60px;
  position: relative;
  z-index: 10;
  overflow: visible; /* 确保连接线不会被裁剪 */
}
</style>